function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from '../../../../../_snowpack/pkg/react.js';
import PropTypes from '../../../../../_snowpack/pkg/prop-types.js';
import { useCombobox } from '../../../../../_snowpack/pkg/downshift.js';
import classNames from '../../../../../_snowpack/pkg/classnames.js';
import { Icon } from '../../../../css/index.js';
import { ChevronButton, Wrapper, Label, Menu, MenuItem, SearchWrapper } from './styles.js';

function DropDown(props) {
  const {
    items,
    selected,
    onTenantChange
  } = props;
  const [inputItems, setInputItems] = useState(items);
  useEffect(() => {
    setInputItems(items);
  }, [items]);
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps,
    openMenu
  } = useCombobox({
    items: inputItems,
    itemToString: item => {
      var _item$name;

      return (_item$name = item === null || item === void 0 ? void 0 : item.name) !== null && _item$name !== void 0 ? _item$name : '';
    },
    onInputValueChange: ({
      inputValue,
      selectedItem
    }) => {
      // hack for having the complete list when there is an item selected
      if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) === inputValue) {
        setInputItems(items);
      } else {
        setInputItems(items.filter(item => item.name.toLowerCase().includes(inputValue.toLowerCase())));
      }
    },
    onSelectedItemChange: onTenantChange,
    selectedItem: selected
  });

  function onSearchWrapperFocus(event) {
    const sidebar = document.querySelector('.sidebar');

    if (sidebar && !sidebar.classList.contains('open')) {
      sidebar.classList.add('open');
    }

    if (!isOpen && typeof event.target.select === 'function') {
      openMenu();
      event.target.select();
    }
  }

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: classNames({
      open: isOpen
    }),
    "data-cypress": "tenant-dropdown"
  }, /*#__PURE__*/React.createElement(Label, _extends({
    className: classNames({
      open: isOpen
    })
  }, getLabelProps()), "Tenant"), /*#__PURE__*/React.createElement(SearchWrapper, _extends({
    className: classNames({
      open: isOpen
    })
  }, getComboboxProps({
    onFocus: onSearchWrapperFocus
  })), /*#__PURE__*/React.createElement("input", getInputProps({})), /*#__PURE__*/React.createElement(ChevronButton, _extends({
    type: "button",
    className: classNames({
      open: isOpen
    })
  }, getToggleButtonProps({
    'aria-label': 'Toggle tenant menu'
  })), /*#__PURE__*/React.createElement(Icon.Arrow, null))), /*#__PURE__*/React.createElement(Menu, _extends({
    className: classNames({
      open: isOpen
    })
  }, getMenuProps()), inputItems.map((item, index) => /*#__PURE__*/React.createElement(MenuItem, _extends({
    key: item.id,
    className: classNames({
      active: highlightedIndex === index,
      selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id
    })
  }, getItemProps({
    item,
    index
  })), item.name))));
}

DropDown.propTypes = {
  onTenantChange: PropTypes.func.isRequired,
  selected: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }))
};
export default DropDown;